import { createAction, props } from '@ngrx/store';
export const fetchAlerts = createAction('[Alerts App] Fetch Alerts');
export const setAlertFetchSuccess = createAction('[Alerts App] Fetch Alerts Success', props());
export const setAlertFetchFailure = createAction('[Alerts App] Fetch Alerts Failure', props());
export const setErrorMessage = createAction('[Alerts App] Set Error Message', props());
export const resetErrorMessage = createAction('[Alerts App] Reset Error Message');
